import { useEffect, useState } from "react";
import { Form, Button, Modal } from "antd";
import ViewingForm from "./ViewingForm";
import DynamicFormFields from "./DynamicFormFields";
import useAxios from "../../hooks/useAxios";

const PvForm = ({
  isService,
  formFields,
  initialValues,
  viewingDataConfig,
  apiConfig,
  onSubmitted,
  submitDisabled = false,
  previousSubmissions,
  submitTransform,
  viewingType,
  viewingModalWidth,
}) => {
  const [form] = Form.useForm();
  const { loading, fetchData } = useAxios();
  const [radioStates, setRadioStates] = useState({});

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  const handleRadioChange = (fieldName, e) => {
    const isDisabled = e.target.value === "disable";
    setRadioStates((prev) => ({ ...prev, [fieldName]: isDisabled }));
    if (isDisabled) form.setFieldsValue({ [fieldName]: "" });
  };

  const handleSubmit = async (values) => {
    if (submitDisabled) {
      return;
    }

    if (isService === true) {
      Modal.confirm({
        title: "Are you sure?",
        okText: "Submit",
        cancelText: "Cancel",
        onOk: () => {
          onSubmitted(values);
          form.resetFields();
        },
      });
    } else {
      const reviewData = {
        ...values,
        ...(apiConfig?.additionalData || {}),
      };
      const requestData = {
        ...(submitTransform ? submitTransform(values) : values),
        ...(apiConfig?.additionalData || {}),
      };

      Modal.confirm({
        title: "Please review your details before submitting.",
        width: viewingModalWidth || "60%",
        content: (
          <ViewingForm
            viewingDataConfig={viewingDataConfig}
            data={reviewData}
            viewingType={viewingType}
          />
        ),
        okText: "Submit",
        cancelText: "Cancel",
        onOk: async () => {
          try {
            const response = await fetchData({
              url: apiConfig?.url,
              method: apiConfig?.method,
              data: requestData,
            });
            if (response) {
              console.log("Response:", response);
            }
            if (onSubmitted) {
              onSubmitted();
            }
            form.resetFields();
          } catch (error) {
            console.error("Error:", error);
          }
        },
      });
    }
  };

  return (
    <Form
      form={form}
      layout="horizontal"
      initialValues={initialValues}
      onFinish={handleSubmit}
    >
      <DynamicFormFields
        fields={formFields}
        form={form}
        radioStates={radioStates}
        onRadioChange={handleRadioChange}
        previousData={previousSubmissions}
      />
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={submitDisabled}
        >
          Review
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PvForm;
